'use strict';

import videojs from 'video.js'
import _ from "lodash";

let Component = videojs.getComponent('Component');

class WatermarkOverlay extends Component {

    constructor(player, options) {
        super(player, options);
        this.elementId = options.elementId;
    }

    createEl() {
        let el = super.createEl('div');
        el.appendChild(document.getElementById(this.options().elementId).childNodes[0]);
        return el;
    }

}

videojs.registerComponent('WatermarkOverlay', WatermarkOverlay);